
import { Link } from 'react-router-dom';

export default function Assessment() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-12 md:py-20 bg-[#153223]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <h2 className="font-['Yeseva_One',serif] text-3xl md:text-5xl text-white mb-4 md:mb-6">
              Assessment & Placement
            </h2>
            <p className="text-base md:text-xl text-[#F5F1E8] mb-4 md:mb-6 leading-relaxed">
              All students begin with a simple <strong className="text-[#FFE66D]">OHT Online English Level Test</strong>, covering:
            </p>
            
            <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
              <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-white">
                <i className="ri-checkbox-circle-fill text-[#FFE66D] text-lg md:text-xl flex-shrink-0"></i>
                <span>Reading fluency</span>
              </li>
              <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-white">
                <i className="ri-checkbox-circle-fill text-[#FFE66D] text-lg md:text-xl flex-shrink-0"></i>
                <span>Vocabulary understanding</span>
              </li>
              <li className="flex items-center gap-2 md:gap-3 text-sm md:text-lg text-white">
                <i className="ri-checkbox-circle-fill text-[#FFE66D] text-lg md:text-xl flex-shrink-0"></i>
                <span>Grammar foundation</span>
              </li>
            </ul>

            <p className="text-sm md:text-lg text-[#F5F1E8] mb-6 md:mb-8 leading-relaxed">
              This ensures each child starts at the correct level for steady improvement.
            </p>

            <Link
              to="/level-test-registration"
              onClick={handleScrollToTop}
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#FFE66D] hover:bg-[#FFD93D] text-[#153223] font-bold px-5 py-2.5 md:px-6 md:py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer text-sm md:text-base"
            >
              <i className="ri-file-list-3-line text-lg md:text-xl"></i>
              Register for Free Online Level Test
            </Link>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/0f4cb3ae9223a7ccb0eb474394930fc5.jpg"
              alt="Student Taking Online Level Test"
              className="rounded-2xl shadow-2xl w-full h-[300px] md:h-[500px] object-cover object-top"
            />
            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-[#FFE66D] p-4 md:p-6 rounded-xl shadow-xl">
              <p className="text-[#153223] font-bold text-base md:text-xl">Free Online Test</p>
              <p className="text-[#153223] text-xs md:text-sm">Personalized Placement</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
